
export class Evento {
    Id: number;
    Datainizio: string;
    Datafine: string;
    Timeinizio: string;
    Timefine: string;
    Titolo: string;
    Note: string;
    Codiceazienda: number;
    Tipoevento: string;

  constructor(){
    this.Id=0;
    this.Datainizio='';
    this.Datafine='';
    this.Timeinizio='';
    this.Timefine='';
    this.Titolo='';
    this.Note='';
    this.Codiceazienda=0;
    this.Tipoevento='';
  }
}
